import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { Controller } from "@commoncore/controller/Controller";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { InviteLinkImplementation } from "../Implementations/InviteLinkImplementation";
import { LocalStorageProps } from "@commoncore/enums/localStorageProps";

export class InviteLinkController extends Controller{
    inviteLinkImplementation:any;
    globalService:any;
    universalService:any;
    static singleInstance = null;
    localStorageService:any;
    public constructor(globalService) {
        super(globalService)
        this.inviteLinkImplementation= new InviteLinkImplementation(globalService);	
      }
      
      public static getInstance(globalService):InviteLinkController{
          if(this.singleInstance == null){
              this.singleInstance = new InviteLinkController(globalService);
              return this.singleInstance;
          }else{
              return this.singleInstance;
          }
      }
  
      public setEnvObjects(globalService){
        this.globalService= globalService
        this.universalService=globalService.getUniversalServiceRef();
        this.localStorageService = globalService.getLocalStorageSvcRef();
      }


    async fetchInviteDetails(inviteKey){
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumInvite"] + inviteKey
        this.inviteLinkImplementation.setHandler(this.globalService);
        try{
            var result = await this.inviteLinkImplementation.fetchInviteDetails(url);
            return result;
        }catch(err){
            console.log("error in fetching invite details -- controller",err);
            return err;
        }
    }

    async fetchPublicInviteDetails(inviteKey){
        let self = this;
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumInvitePublic"] + inviteKey
        self.inviteLinkImplementation.setHandler(self.globalService);
        try{
            var result = await self.inviteLinkImplementation.fetchPublicInviteDetails(url);
            return result;
        }catch(err){
            console.log("error in fetching invite details -- controller",err);
            return err;
        }
    }

      async acceptAlbumInvitation(){
        let self = this;
        var inviteKey = self.localStorageService.getInviteKey(LocalStorageProps.INVITE_KEY)
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumInvite"] + inviteKey + ENV_CONFIG.commonUrls["acceptAlbumInvite"]
        self.inviteLinkImplementation.setHandler(self.globalService);
          try{
              var result = await self.inviteLinkImplementation.acceptInvitationForAlbum(url);
              return result;
          }catch(err){
                console.log("error in fetching invite details",err)
                return err;
          }
      }
  
}